document.addEventListener('DOMContentLoaded', function () {
  const calculator = document.querySelector('[data-shipping-calculator]');
  if (!calculator) return;

  const input = calculator.querySelector('.gj-cep-input');
  const btn = calculator.querySelector('[data-shipping-btn]');
  const results = calculator.querySelector('.gj-shipping-results');

  // --- Sanitização (evitar XSS) ---
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // --- Máscara de CEP ---
  function maskCep(value) {
    const digits = value.replace(/\D/g, '').slice(0, 8);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  input.addEventListener('input', function () {
    this.value = maskCep(this.value);
  });

  input.addEventListener('paste', function () {
    setTimeout(() => {
      this.value = maskCep(this.value);
    }, 0);
  });

  // --- Obter Variant ID atual ---
  function getVariantId() {
    const select = document.querySelector('.gj-product-form select[name="id"]');
    if (select) return select.value;
    const hidden = document.querySelector('.gj-product-form input[name="id"]');
    return hidden ? hidden.value : null;
  }

  // --- Exibir estados ---
  function showResults(html) {
    results.innerHTML = html;
    results.style.display = 'block';
  }

  function showError(msg) {
    showResults('<p class="gj-shipping-error">' + escapeHtml(msg) + '</p>');
  }

  function showLoading() {
    showResults('<p class="gj-shipping-loading">Consultando...</p>');
  }

  // --- Formatar preço ---
  function formatPrice(value) {
    // A API retorna price em centavos (inteiro ou string)
    const cents = parseInt(String(value).replace(/\D/g, ''), 10);
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  // --- Formatar prazo ---
  function formatDeadline(rate) {
    // delivery_range pode ser [int, int] ou ["2026-03-24", "2026-03-28"]
    if (Array.isArray(rate.delivery_range) && rate.delivery_range.length === 2) {
      var v0 = rate.delivery_range[0];
      var v1 = rate.delivery_range[1];
      if (typeof v0 === 'number' && typeof v1 === 'number') {
        if (v0 === v1) return v0 + ' dia' + (v0 !== 1 ? 's' : '') + ' úteis';
        return v0 + '-' + v1 + ' dias úteis';
      }
      // Strings de data: calcular diferença em dias
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var d0 = new Date(String(v0) + 'T00:00:00');
      var d1 = new Date(String(v1) + 'T00:00:00');
      var days0 = Math.round((d0 - today) / 86400000);
      var days1 = Math.round((d1 - today) / 86400000);
      if (days0 > 0 && days1 > 0) {
        if (days0 === days1) return days0 + ' dia' + (days0 !== 1 ? 's' : '') + ' úteis';
        return days0 + '-' + days1 + ' dias úteis';
      }
    }
    // Fallback: min/max_delivery_date
    if (rate.min_delivery_date && rate.max_delivery_date) {
      var today2 = new Date();
      today2.setHours(0, 0, 0, 0);
      var minDate = new Date(rate.min_delivery_date + 'T00:00:00');
      var maxDate = new Date(rate.max_delivery_date + 'T00:00:00');
      var minDays = Math.round((minDate - today2) / 86400000);
      var maxDays = Math.round((maxDate - today2) / 86400000);
      if (minDays > 0 && maxDays > 0) {
        if (minDays === maxDays) return minDays + ' dia' + (minDays !== 1 ? 's' : '') + ' úteis';
        return minDays + '-' + maxDays + ' dias úteis';
      }
    }
    return '—';
  }

  // --- Renderizar lista de fretes ---
  function renderRates(rates) {
    if (!rates || rates.length === 0) {
      showError('Não encontramos opções de frete para este CEP.');
      return;
    }
    // Filtrar opções com preço zero (ex: "Standard"), mas manter Local Delivery/Pickup
    var filtered = rates.filter(function (rate) {
      var name = (rate.name || '').toLowerCase();
      var isLocal = name.indexOf('local') !== -1 || name.indexOf('pick') !== -1 || name.indexOf('retirada') !== -1;
      if (isLocal) return true;
      return parseInt(String(rate.price).replace(/\D/g, ''), 10) > 0;
    });

    // Adicionar Retirada no Local grátis como primeira opção (se não veio da API)
    var hasRetirada = filtered.some(function (rate) {
      var name = (rate.name || '').toLowerCase();
      return name.indexOf('pick') !== -1 || name.indexOf('retirada') !== -1;
    });
    if (!hasRetirada) {
      filtered.unshift({ name: 'Retirada no Local', price: '0', delivery_range: null, _fixed: true });
    }

    if (filtered.length === 0) {
      showError('Não encontramos opções de frete para este CEP.');
      return;
    }
    var rows = filtered.map(function (rate) {
      var rawName = rate.name || '';
      // Traduzir nomes de entrega local
      if (/local.*(deliver|entrega)/i.test(rawName)) {
        rawName = 'Entrega Local';
      } else if (/local.*(pick|retirada|coleta)/i.test(rawName) || /pick.*up/i.test(rawName)) {
        rawName = 'Retirada no Local';
      }
      var name = escapeHtml(rawName);
      var deadline = rate._fixed ? '—' : escapeHtml(formatDeadline(rate));
      var priceValue = parseInt(String(rate.price).replace(/\D/g, ''), 10);
      var price = priceValue === 0 ? 'Grátis' : escapeHtml(formatPrice(rate.price));
      return '<div class="gj-shipping-result-row">' +
        '<span class="gj-shipping-result-name">' + name + '</span>' +
        '<span class="gj-shipping-result-deadline">' + deadline + '</span>' +
        '<span class="gj-shipping-result-price">' + price + '</span>' +
        '</div>';
    }).join('');
    showResults(rows);
  }

  // --- Quantidade atual deste produto no carrinho ---
  async function getCartVariantQty(variantId) {
    try {
      var resp = await fetch('/cart.js');
      if (!resp.ok) return 0;
      var cart = await resp.json();
      var vid = Number(variantId);
      return (cart.items || []).reduce(function (sum, item) {
        return item.variant_id === vid ? sum + item.quantity : sum;
      }, 0);
    } catch (e) {
      return 0;
    }
  }

  // --- Buscar estado pelo CEP (ViaCEP) ---
  async function getProvince(cep) {
    try {
      var resp = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
      if (!resp.ok) return '';
      var data = await resp.json();
      return data.uf || '';
    } catch (e) {
      return '';
    }
  }

  // --- Handler principal ---
  btn.addEventListener('click', async function () {
    var rawCep = input.value.replace(/\D/g, '');

    if (rawCep.length < 8) {
      showError('CEP inválido. Digite os 8 números.');
      return;
    }

    var variantId = getVariantId();
    if (!variantId) {
      showError('Erro ao identificar o produto. Recarregue a página.');
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Consultando...';
    showLoading();

    // A cotação de frete do Shopify usa o carrinho. Para não alterar o carrinho do
    // cliente, só adicionamos o produto se ele ainda não estiver lá — e revertemos no final.
    var prevQty = await getCartVariantQty(variantId);
    var didAdd = false;

    try {
      // 1. Buscar estado pelo CEP
      var province = await getProvince(rawCep);

      // 2. Adicionar ao carrinho apenas se necessário (somente para conseguir cotar)
      if (prevQty === 0) {
        var cartResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (!cartResponse.ok) {
          showError('Não foi possível calcular o frete. Tente novamente.');
          return;
        }
        didAdd = true;
      }

      // 3. Consultar cotações de frete com estado
      var ratesUrl =
        '/cart/shipping_rates.json?shipping_address[zip]=' + rawCep +
        '&shipping_address[country]=BR&shipping_address[province]=' + encodeURIComponent(province);

      var ratesResponse = await fetch(ratesUrl);

      if (!ratesResponse.ok) {
        showError('Erro ao consultar. Tente novamente.');
        return;
      }

      var data = await ratesResponse.json();
      var rates = data.shipping_rates || [];
      renderRates(rates);

    } catch (err) {
      showError('Erro ao consultar. Tente novamente.');
    } finally {
      // Reverter: tira do carrinho o item que adicionamos só para a cotação.
      if (didAdd) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 0 }),
          });
        } catch (e) {}
      }
      btn.disabled = false;
      btn.textContent = 'Consultar';
    }
  });

  // Permitir Enter no input
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') btn.click();
  });
});
